var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { twMerge } from 'tailwind-merge';
export const Root = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div className={twMerge('flex flex-col flex-initial gap-2 items-center', className)} {...props}/>);
};
export const Indicator = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div className={twMerge('rounded-full h-8 w-8 text-sm sm:text-base justify-center items-center flex flex-initial border border-light-4', className)} {...props}/>);
};
export const Description = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<span className={twMerge('text-center text-xs sm:text-base max-w-[150px]', className)} {...props}/>);
};
export const Spacer = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div className={twMerge('w-0 sm:w-24 h-[1px] bg-white rounded flex self-center', className)} {...props}/>);
};
